module.exports = "1. 这是说明信息\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./static/specTracker/specTracker-11.txt
// module id = EGWG
// module chunks = 2